import styled, { css, DefaultTheme } from 'styled-components'

import { TimeStatus } from 'common/enum/time-status'

type CardEventProps = {
  timeStatus?: TimeStatus
  selectedRequest?: boolean
}

const timeStatusVariants = (theme: DefaultTheme, timeStatus: TimeStatus) => {
  switch (timeStatus) {
    case TimeStatus.SCHEDULED:
      return css`
        background-color: ${theme.ds.colors.primary50};
        border-color: ${theme.ds.colors.primary300};

        ${CardTitle},
        ${CardSubtitle},
        ${CardTimeText} {
          color: ${theme.ds.colors.primary600};
        }
      `
    case TimeStatus.INTERDICTED:
      return css`
        background-color: ${theme.ds.colors.terciary50};
        border-color: ${theme.ds.colors.terciary100};

        ${CardTitle},
        ${CardSubtitle},
        ${CardTimeText} {
          color: ${theme.ds.colors.terciary700};
        }
      `
    // REQUESTED
    case TimeStatus.REQUESTED:
      return css`
        background-color: ${theme.ds.colors.neutral100};
        border-color: ${theme.ds.colors.neutral500};

        ${CardTitle},
        ${CardSubtitle},
        ${CardTimeText} {
          color: ${theme.ds.colors.neutral500};
        }
      `

    // OPEN
    case TimeStatus.OPEN:
      return css`
        background-color: ${theme.ds.colors.white};
        border-color: ${theme.ds.colors.neutral100};

        ${CardTitle},
        ${CardSubtitle},
        ${CardTimeText} {
          color: ${theme.ds.colors.neutral500};
        }
      `

    // PREPARATION
    default:
      return css`
        background-color: ${theme.ds.colors.secondary50};
        border-color: ${theme.ds.colors.secondary200};

        ${CardTitle},
        ${CardSubtitle},
        ${CardTimeText} {
          color: ${theme.ds.colors.secondary800};
        }
      `
  }
}

export const CardEvent = styled.div<CardEventProps>`
  ${({ theme, timeStatus, selectedRequest }) => css`
    cursor: pointer;
    font-family: 'Poppins';
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    border-radius: 8px;
    padding: ${timeStatus === TimeStatus.PREPARATION ? '0 8px' : '8px'};
    font-size: 16px;
    border: 1px solid white;
    border: ${selectedRequest ? '2px solid green' : '1px solid white'};
    border-color: ${selectedRequest ? '#5ACA65 !important' : ''};
    box-shadow: ${selectedRequest ? '3px 1px 3px grey' : ''};

    ${timeStatus && timeStatusVariants(theme, timeStatus)}
  `}
`

export const CardTitle = styled.h6<CardEventProps>`
  ${({ theme, selectedRequest }) => css`
    font-size: ${theme.ds.typography.size.xxsmall};
    font-weight: ${theme.ds.typography.weight.bold};
    line-height: ${theme.ds.typography.lineHeight.medium};
    color: ${theme.ds.colors.neutral800};
    color: ${!!selectedRequest && '#5ACA65 !important'};
    word-wrap: break-word;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  `}
`

export const CardSubtitle = styled.span<CardEventProps>`
  ${({ theme, selectedRequest }) => css`
    margin-top: 0;
    margin-bottom: auto;
    font-size: ${theme.ds.typography.size.xxsmall};
    color: ${theme.ds.colors.neutral800};
    color: ${!!selectedRequest && '#5ACA65 !important'};
    font-weight: ${theme.ds.typography.weight.normal};
    word-wrap: break-word;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  `}
`

export const CardTimeText = styled.span<CardEventProps>`
  ${({ theme, selectedRequest }) => css`
    font-size: ${theme.ds.typography.size.xxsmall};
    color: ${theme.ds.colors.neutral800};
    color: ${!!selectedRequest && '#5ACA65 !important'};
    font-weight: ${theme.ds.typography.weight.normal};
    line-height: 1;
  `}
`

export const ModalInfo = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const Title = styled.h3`
  font-size: ${({ theme }) => theme.font.sizes.small};
  font-weight: ${({ theme }) => theme.font.semiBold};
  color: ${({ theme }) => theme.colors.neutralBlack};
`

export const Subtitle = styled.h3`
  color: ${({ theme }) => theme.colors.gray};
  font-size: ${({ theme }) => theme.ds.typography.size.small};
  font-weight: ${({ theme }) => theme.font.semiBold};
`

export const HeaderModal = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  /* margin-bottom: 20px; */
`

export const DateTitle = styled.h2`
  display: flex;
  justify-content: space-between;
  svg {
    cursor: pointer;
  }
`

export const SurgeryCenterTitle = styled.div`
  margin-top: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 35px;
  background-color: ${({ theme }) => theme.ds.colors.neutral50};
  color: ${({ theme }) => theme.colors.gray};
  font-size: ${({ theme }) => theme.ds.typography.size.small};
  font-weight: ${({ theme }) => theme.font.semiBold};
  text-align: center;
`
